import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Color tokens per status string
 .* bg: pill background, color: text color
 .*/
const STATUS_COLORS = {
  // Blue — active / open
  Active:       { bg: '#E3F2FD', color: '#1565C0' },
  Open:         { bg: '#E3F2FD', color: '#1565C0' },
  // Amber — in progress / pending / awaiting
  'In Progress':        { bg: '#FFF8E1', color: '#E65100' },
  Pending:              { bg: '#FFF8E1', color: '#E65100' },
  'Pending (Awaiting Supplier)': { bg: '#FFF8E1', color: '#E65100' },
  'Awaiting Quote':     { bg: '#FFF8E1', color: '#F57F17' },
  Draft:                { bg: '#FFF8E1', color: '#E65100' },
  // Green — completed / delivered / received / restocked
  Completed:    { bg: '#E8F5E9', color: '#2E7D32' },
  Delivered:    { bg: '#E8F5E9', color: '#2E7D32' },
  Received:     { bg: '#E8F5E9', color: '#2E7D32' },
  Restocked:    { bg: '#E8F5E9', color: '#2E7D32' },
  Paid:         { bg: '#E8F5E9', color: '#2E7D32' },
  Available:    { bg: '#E8F5E9', color: '#2E7D32' },
  // Purple — in transit / inspecting
  'In Transit': { bg: '#EDE7F6', color: '#4527A0' },
  Submitted:    { bg: '#EDE7F6', color: '#4527A0' },
  Inspecting:   { bg: '#EDE7F6', color: '#4527A0' },
  // Red — cancelled / scrapped / out of stock / overdue
  Cancelled:    { bg: '#FFEBEE', color: '#B71C1C' },
  Scrapped:     { bg: '#FFEBEE', color: '#B71C1C' },
  'Out of Stock': { bg: '#FFEBEE', color: '#B71C1C' },
  Overdue:      { bg: '#FFEBEE', color: '#B71C1C' },
  // Teal — fulfilled / in repair / reserved / returned to supplier
  Fulfilled:              { bg: '#E0F2F1', color: '#00695C' },
  'In Repair':            { bg: '#E0F2F1', color: '#00695C' },
  Reserved:               { bg: '#E0F2F1', color: '#00695C' },
  'Returned to Supplier': { bg: '#E0F2F1', color: '#00695C' },
  // Grey — history / unknown / inactive
  History:      { bg: '#ECEFF1', color: '#546E7A' },
  Inactive:     { bg: '#ECEFF1', color: '#546E7A' },
  'Low Stock':  { bg: '#FFF3E0', color: '#BF360C' },
  Refurbish:    { bg: '#FFF3E0', color: '#BF360C' },
  // Blue — warehouse location type
  Warehouse:    { bg: '#E3F2FD', color: '#1565C0' },
  // Teal — FSL location type
  FSL:          { bg: '#E0F2F1', color: '#00695C' },
  // Amber — on-site customer location type
  'On-Site':    { bg: '#FFF8E1', color: '#F57C00' },
  // Indigo — supplier / vendor direct fulfillment
  Supplier:     { bg: '#E8EAF6', color: '#3949AB' },
  // Purple — shipped (serial items)
  Shipped:      { bg: '#EDE7F6', color: '#4527A0' },
};

const DEFAULT = { bg: '#ECEFF1', color: '#546E7A' };

/**
 * @param {{ status: string }} props
 */
export default function StatusBadge({ status }) {
  const { bg, color } = STATUS_COLORS[status] ?? DEFAULT;

  return (
    <Box
      sx={{ display: 'inline-flex',
        alignItems: 'center',
        px: '10px',
        py: '3px',
        borderRadius: '12px',
        backgroundColor: bg,
      }}
    >
      <Typography
        sx={{ fontSize: '0.75rem',
          fontWeight: 600,
          color,
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        {status}
      </Typography>
    </Box>
  );
}
